import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { FileEntity } from './FileEntity.entity';
import { User } from './User.entity';

export class NoteAttachment<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: benutzerCode */
  userId?: number;
  /** Alias: datum */
  date?: string;
  /** Alias: filename */
  fileName?: string;
  /** Alias: notiz */
  note?: string;
  /** Alias: objCode */
  objId?: number;
  /** Alias: fileInfos */
  fileInfos?: FileEntity<T>;
  /** Alias: benutzer */
  user?: User<T>;

  __typename?: string;
}

const fields: FieldDefinitions<NoteAttachment> = {
  id: {
    alias: 'code',
  },
  userId: {
    alias: 'benutzerCode',
  },
  date: {
    alias: 'datum',
  },
  fileName: {
    alias: 'filename',
  },
  note: {
    alias: 'notiz',
  },
  objId: {
    alias: 'objCode',
  },
  fileInfos: {
    alias: 'fileInfos',
    entity: Entities.fileEntity,
  },
  user: {
    alias: 'benutzer',
    entity: Entities.user,
  },
  __typename: {
    alias: '__typename',
  },
};

export const noteAttachmentEntityDefinition: EntitiyDefinition<NoteAttachment> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'NotizAnhang',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'upsertNotizAnhang',
          args: [
            { name: 'input', type: 'InputNotizAnhang!' },
            { name: 'drySave', type: 'Boolean' },
          ],
        },
      },
    },
    fieldDefinitions: fields,
  };
